export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  categorySlug: string;
  status: string;
  rating: number;
  description: string;
  chapters: number;
  updateDate: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const comics: Comic[] = [
  {
    id: 1,
    title: "斗破苍穹",
    author: "天蚕土豆",
    cover: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20martial%20arts%20fantasy%20comic%20cover%2C%20young%20warrior%20with%20flaming%20fist%20in%20ancient%20oriental%20setting%2C%20dramatic%20dynamic%20composition%2C%20warm%20golden%20and%20red%20tones%2C%20manga%20style%20illustration&width=400&height=560&seq=comic-cover-01&orientation=portrait",
    category: "热血",
    categorySlug: "rexue",
    status: "连载中",
    rating: 9.6,
    description: "天才少年萧炎在创造了家族空前绝后的修炼纪录后突然成了废人，种种打击接踵而至。就在他即将绝望的时候，一缕灵魂从他手上的戒指里浮现，一扇全新的大门在面前开启...",
    chapters: 1234,
    updateDate: "2026-08-01",
    tags: ["玄幻", "热血", "战斗"],
    isHot: true,
    isNew: false,
  },
  {
    id: 2,
    title: "一人之下",
    author: "米二",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20supernatural%20action%20comic%20cover%2C%20young%20man%20with%20mysterious%20powers%20in%20modern%20city%2C%20traditional%20Taoist%20elements%20mixed%20with%20urban%20setting%2C%20dynamic%20ink%20wash%20painting%20style&width=400&height=560&seq=comic-cover-02&orientation=portrait",
    category: "热血",
    categorySlug: "rexue",
    status: "连载中",
    rating: 9.5,
    description: "随着爷爷尸体被盗，神秘少女冯宝宝的造访，少年张楚岚的平静校园生活被彻底颠覆。急于解开爷爷和自身秘密的张楚岚，开始踏入了异人的世界...",
    chapters: 680,
    updateDate: "2026-07-30",
    tags: ["异能", "热血", "搞笑"],
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    title: "星辰变",
    author: "我吃西红柿",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20cultivation%20fantasy%20comic%20cover%2C%20young%20immortal%20cultivator%20surrounded%20by%20stars%20and%20cosmic%20energy%2C%20ethereal%20celestial%20palace%20background%2C%20mystical%20blue%20and%20purple%20tones&width=400&height=560&seq=comic-cover-03&orientation=portrait",
    category: "奇幻",
    categorySlug: "qihuan",
    status: "已完结",
    rating: 9.3,
    description: "一名孩童，天生拥有无法修炼的废物体质，但他没有放弃，凭借一颗坚毅的心、一部神秘的功法，走上了一条与众不同的修炼之路...",
    chapters: 520,
    updateDate: "2026-06-15",
    tags: ["修仙", "奇幻", "冒险"],
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    title: "怦然心动",
    author: "kid岁",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20youth%20school%20life%20comic%20cover%2C%20young%20couple%20under%20cherry%20blossom%20trees%20in%20spring%2C%20soft%20pink%20and%20warm%20pastel%20tones%2C%20sweet%20heartwarming%20illustration%20style&width=400&height=560&seq=comic-cover-04&orientation=portrait",
    category: "恋爱",
    categorySlug: "lianai",
    status: "连载中",
    rating: 9.4,
    description: "高中生狄淇儿与江应怜，从初识到相知，经历青春期的懵懂、悸动与成长。一段纯真美好的校园恋爱故事...",
    chapters: 280,
    updateDate: "2026-07-28",
    tags: ["校园", "恋爱", "青春"],
    isHot: true,
    isNew: false,
  },
  {
    id: 5,
    title: "十万个冷笑话",
    author: "寒舞",
    cover: "https://readdy.ai/api/search-image?query=Comedy%20parody%20comic%20cover%20with%20exaggerated%20funny%20expressions%2C%20colorful%20cartoon%20characters%20in%20absurd%20situations%2C%20bright%20playful%20colors%2C%20humorous%20chibi%20style&width=400&height=560&seq=comic-cover-05&orientation=portrait",
    category: "搞笑",
    categorySlug: "gaoxiao",
    status: "连载中",
    rating: 9.2,
    description: "由一系列吐槽短篇组成，以幽默诙谐的方式重新演绎经典故事和神话传说，脑洞大开，笑点不断...",
    chapters: 450,
    updateDate: "2026-07-25",
    tags: ["搞笑", "吐槽", "脑洞"],
    isHot: false,
    isNew: true,
  },
  {
    id: 6,
    title: "深海探秘",
    author: "深海工作室",
    cover: "https://readdy.ai/api/search-image?query=Mysterious%20deep%20sea%20adventure%20comic%20cover%2C%20divers%20exploring%20ancient%20underwater%20ruins%20with%20strange%20creatures%2C%20dark%20blue%20ocean%20depths%20with%20bioluminescent%20lights%2C%20atmospheric%20suspenseful%20illustration&width=400&height=560&seq=comic-cover-06&orientation=portrait",
    category: "冒险",
    categorySlug: "maoxian",
    status: "连载中",
    rating: 9.1,
    description: "一支深海探险队在一次任务中意外发现了失落的水下文明，随之而来的是一连串惊心动魄的冒险...",
    chapters: 156,
    updateDate: "2026-08-01",
    tags: ["冒险", "海洋", "探索"],
    isHot: false,
    isNew: true,
  },
  {
    id: 7,
    title: "怪诞小镇",
    author: "林欣",
    cover: "https://readdy.ai/api/search-image?query=Mystery%20supernatural%20comic%20cover%2C%20strange%20small%20town%20with%20weird%20occurrences%2C%20two%20teenagers%20investigating%20mysteries%2C%20dark%20forest%20with%20glowing%20eyes%2C%20eerie%20atmospheric%20style&width=400&height=560&seq=comic-cover-07&orientation=portrait",
    category: "悬疑",
    categorySlug: "xuanyi",
    status: "已完结",
    rating: 9.0,
    description: "双胞胎兄妹暑假来到一个神秘小镇，发现镇上充满了超自然现象，他们开始了一场惊险的解谜之旅...",
    chapters: 200,
    updateDate: "2026-05-20",
    tags: ["悬疑", "超自然", "冒险"],
    isHot: false,
    isNew: false,
  },
  {
    id: 8,
    title: "暗夜行者",
    author: "墨渊",
    cover: "https://readdy.ai/api/search-image?query=Dark%20urban%20fantasy%20comic%20cover%2C%20mysterious%20hooded%20figure%20in%20rainy%20neon-lit%20city%20alley%2C%20cyberpunk%20atmosphere%2C%20dark%20atmospheric%20tones%20with%20pops%20of%20neon%20color&width=400&height=560&seq=comic-cover-08&orientation=portrait",
    category: "动作",
    categorySlug: "dongzuo",
    status: "连载中",
    rating: 8.9,
    description: "在未来的赛博城市中，一名拥有特殊能力的暗夜行者，游走在正义与黑暗的边缘，守护城市的和平...",
    chapters: 89,
    updateDate: "2026-07-31",
    tags: ["动作", "科幻", "赛博朋克"],
    isHot: false,
    isNew: true,
  },
  {
    id: 9,
    title: "校园日记",
    author: "夏小沫",
    cover: "https://readdy.ai/api/search-image?query=Slice%20of%20life%20school%20comedy%20comic%20cover%2C%20group%20of%20high%20school%20friends%20laughing%20in%20classroom%2C%20bright%20sunny%20day%2C%20warm%20cheerful%20pastel%20colors%2C%20cute%20illustration%20style&width=400&height=560&seq=comic-cover-09&orientation=portrait",
    category: "校园",
    categorySlug: "xiaoyuan",
    status: "连载中",
    rating: 9.3,
    description: "记录了一群高中生的日常校园生活，有欢笑有泪水，有友情有成长，是最真实的青春印记...",
    chapters: 340,
    updateDate: "2026-07-29",
    tags: ["校园", "日常", "友情"],
    isHot: true,
    isNew: false,
  },
  {
    id: 10,
    title: "星际迷航记",
    author: "星河",
    cover: "https://readdy.ai/api/search-image?query=Space%20sci-fi%20comic%20cover%2C%20spaceship%20flying%20through%20colorful%20nebula%20with%20planets%2C%20futuristic%20astronaut%20characters%2C%20epic%20cosmic%20scale%2C%20vibrant%20purple%20and%20blue%20galaxy&width=400&height=560&seq=comic-cover-10&orientation=portrait",
    category: "科幻",
    categorySlug: "kehuan",
    status: "连载中",
    rating: 9.0,
    description: "人类进入星际时代，一艘探索飞船在未知星域发现了外星文明遗迹，由此展开了一段波澜壮阔的星际冒险...",
    chapters: 178,
    updateDate: "2026-07-27",
    tags: ["科幻", "太空", "冒险"],
    isHot: false,
    isNew: false,
  },
  {
    id: 11,
    title: "午夜怪谈",
    author: "鬼手",
    cover: "https://readdy.ai/api/search-image?query=Horror%20supernatural%20comic%20cover%2C%20dark%20haunted%20house%20with%20ghostly%20figure%20in%20window%2C%20full%20moon%20night%2C%20bare%20tree%20branches%2C%20creepy%20atmospheric%20black%20and%20red%20illustration&width=400&height=560&seq=comic-cover-11&orientation=portrait",
    category: "恐怖",
    categorySlug: "kongbu",
    status: "连载中",
    rating: 8.7,
    description: "收集了各种都市传说和民间鬼故事，以漫画形式呈现。每一个午夜，都有一个恐怖故事等着你...",
    chapters: 95,
    updateDate: "2026-07-26",
    tags: ["恐怖", "灵异", "短篇"],
    isHot: false,
    isNew: false,
  },
  {
    id: 12,
    title: "江湖风云录",
    author: "剑客行",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20wuxia%20comic%20cover%2C%20swordsman%20standing%20on%20bamboo%20forest%20peak%20at%20sunset%2C%20flowing%20robes%20in%20wind%2C%20traditional%20ink%20painting%20aesthetic%20with%20warm%20orange%20sunset&width=400&height=560&seq=comic-cover-12&orientation=portrait",
    category: "热血",
    categorySlug: "rexue",
    status: "已完结",
    rating: 9.4,
    description: "一个平凡少年意外获得绝世武功秘籍，踏入江湖，历经恩怨情仇，最终成为一代大侠的传奇故事...",
    chapters: 890,
    updateDate: "2026-04-10",
    tags: ["武侠", "热血", "江湖"],
    isHot: false,
    isNew: false,
  },
];

export const getComicsByCategory = (slug: string): Comic[] => {
  return comics.filter((c) => c.categorySlug === slug);
};

export const getHotComics = (): Comic[] => {
  return comics.filter((c) => c.isHot);
};

export const getNewComics = (): Comic[] => {
  return comics.filter((c) => c.isNew);
};

export const getComicById = (id: number): Comic | undefined => {
  return comics.find((c) => c.id === id);
};